import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpLogoText } from "./styles";

export type HeaderFeaturesLogoTextLinkProps = HeaderFeatureCommonProps & {
  size?: HeaderFeaturesLogoTextLinkSize;
};

export type HeaderFeaturesLogoTextLinkSize = "default" | "large" | "small";

export const HeaderFeaturesLogoTextLink: FunctionComponent<HeaderFeaturesLogoTextLinkProps> = ({
  size = "default",
  ...props
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpLogoText $size={size} />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesLogoTextLink.displayName = "HeaderFeaturesLogoTextLink";
